import classNames from 'classnames';
import * as React from 'react';
import { CloudChildProduct } from '@atlassian/cssxp-typescommon';
import { getEntitlementName } from '@atlassian/temp-helper';
import EntitlementIcon from '../../entitlement-icon';
import EvalLozenge from '../../eval-lozenge';

export interface Props extends CloudChildProduct {
  colSpan: number;
  isParentDeactivated: boolean;
}

export default function ChildProductRow(props: Props) {
  const { productId, unitCount, planType, billingStatus, colSpan, isParentDeactivated } = props;

  const users = typeof unitCount === 'number' ? `${unitCount} users` : unitCount;

  const isDeleted = billingStatus === 'DELETED';

  const isSuspended = isParentDeactivated || billingStatus === 'SUSPENDED';

  const isActive = !isParentDeactivated && billingStatus === 'ACTIVE';

  const isEvaluation = planType === 'EVALUATION';

  const name = getEntitlementName(props);

  return (
    <tr
      className={classNames({
        'search-result-child': true,
        eval: isEvaluation,
        removed: isDeleted,
        'suspended-child': isSuspended,
      })}
      data-testid={`cloud-subscription-child-product-row`}
    >
      <td title={name} className="entitlement-name">
        <a>
          <EntitlementIcon productId={productId} className="avatar" isCloud />
          {name}
        </a>{' '}
        {isEvaluation && <EvalLozenge />}
      </td>
      <td className="entitlement-user-tier" colSpan={colSpan - 1}>
        {isDeleted && 'removed'}
        {isActive && users}
      </td>
    </tr>
  );
}
